module.exports = __webpack_public_path__ + "media/icons/icon_souzoku-c0c6ad08.png";